import { getValueSafely } from 'utils/utils';
import { colours } from 'styling/colours';
import useDevice from 'hooks/useDevice';
import { Asset } from 'types/asset';
import ViewAssetOnMapLink from './ViewAssetOnMapLink';

export default function LocationSection({ asset }: { asset: Asset }) {
  const buildingNamesArray = asset.location?.building_level?.possible_buildings || [];
  const buildingName = getValueSafely(buildingNamesArray[0]?.name);
  const { isMobileDevice } = useDevice();

  const buildingLevelName = getValueSafely(asset.location?.building_level?.level.name);
  const assetIsOutdoor = asset.location?.is_outdoors;
  return (
    <>
      {assetIsOutdoor ? (
        <>
          <span style={{ marginBottom: '10px' }}>Outside Mapped Buildings</span>

          <div className="region">
            <div
              style={{
                color: colours.secondaryText,
                margin: !isMobileDevice ? '15px 0 10px 0' : '15px 0 0 0',
              }}
            >
              Possible region:
            </div>
            <div>{getValueSafely(asset.location?.region?.name)}</div>
          </div>
        </>
      ) : (
        <>
          <span style={{ marginBottom: '10px' }}>{`${buildingLevelName}/${buildingName}`}</span>
          <div className="region">
            <div
              style={{
                color: colours.secondaryText,
                margin: !isMobileDevice ? '15px 0 10px 0' : '15px 0 0 0',
              }}
            >
              Possible region:
            </div>
            <div>{getValueSafely(asset.location?.region?.name)}</div>
          </div>
        </>
      )}
      {!isMobileDevice && asset.location && (
        <ViewAssetOnMapLink asset={asset} />
      )}
    </>
  );
}
